import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import routes from "common/routes";
import LastRaceIcon from "components/Icons/LastRace";
import CustomRaceIcon from "components/Icons/CustomRace";
import Link from "components/Link";
import MatchesCount from "components/MatchesCount";
import useStyles from "./styles";

interface IProps {
  matchedHorses: racehorse360.IHorse[] | null;
}

const Matches = React.memo((props: IProps) => {
  const { matchedHorses } = props;
  const classes = useStyles();
  const lastRaceMatchesHorses = matchedHorses
    ? matchedHorses.filter((horse: racehorse360.IHorse) => {
        return horse.areLastRacePreferredConditionsSelected;
      })
    : [];
  const customMatchesHorses = matchedHorses
    ? matchedHorses.filter((horse: racehorse360.IHorse) => {
        return !horse.areLastRacePreferredConditionsSelected;
      })
    : [];

  const renderHorsesNames = (horses: racehorse360.IHorse[]) => {
    return horses.map((horse: racehorse360.IHorse, index: number) => {
      return (
        <Link
          key={horse.id}
          to={routes.horseDetails.path.replace(":horseId", String(horse.id))}
        >
          <span className={classes.horseName}>{horse.name}</span>
          {horses.length - 1 === index ? "" : ","}&nbsp;
        </Link>
      );
    });
  };

  return (
    <div>
      <div className={classes.matchesHeader}>
        <MatchesCount
          matchedHorsesCount={matchedHorses?.length || 0}
          customStyles={{ width: 15, height: 15, fontSize: 11 }}
        />
        <span className={classes.matchesHeaderText}>Matches</span>
      </div>
      <div>
        {Boolean(lastRaceMatchesHorses.length) && (
          <div className={classes.matchesType}>
            <LastRaceIcon className={classes.lastRaceIconDetails} />
            <div className={classes.horsesNamesList}>
              {renderHorsesNames(lastRaceMatchesHorses)}
            </div>
          </div>
        )}
        {Boolean(customMatchesHorses.length) && (
          <div className={classes.matchesType}>
            <CustomRaceIcon className={classes.customIconDetails} />
            <div className={classes.horsesNamesList}>
              {renderHorsesNames(customMatchesHorses)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default Matches;
